// Клиент админских эндпоинтов актуализации цен: настройки фичи и токен
// Travelpayouts. Типы списаны с server/prices/settings.mjs и routes.mjs —
// сервер здесь первичен, клиент ничего не додумывает.
import { request } from '../auth/request';
import type { ApiResult } from '../auth/request';

/** Те же три источника, что и в server/prices/settings.mjs (PROVIDERS). */
export type PriceProvider = 'travelpayouts' | 'websearch' | 'page';

export const PRICE_PROVIDERS: readonly PriceProvider[] = ['travelpayouts', 'websearch', 'page'];

export interface PricesSettings {
  enabled: boolean;
  providers: Record<PriceProvider, boolean>;
  /** Сколько рейсов сервер берёт за одну проверку: 1…20. */
  maxFlights: number;
  /** Коридор вменяемости: найденная цена вне [база × min, база × max] отбрасывается. */
  sanityMin: number;
  sanityMax: number;
}

/**
 * Что сервер рассказывает о токене: сам токен наружу не уходит никогда —
 * только признак наличия и последние 4 символа, как у `ai.apiKey`.
 * `source: 'env'` — токен пришёл из окружения, из админки его не стереть.
 */
export interface TravelpayoutsInfo {
  present: boolean;
  source: 'db' | 'env' | null;
  tail: string;
  /** Партнёрский маркер — не секрет, приезжает как есть. */
  marker: string;
}

export interface PricesSettingsView {
  settings: PricesSettings;
  travelpayouts: TravelpayoutsInfo;
  updatedAt: number | null;
  /** id администратора, сохранившего настройки; '' — их ещё не сохраняли. */
  updatedBy: string;
}

/**
 * Токен и маркер сервер хранит одной строкой (`setTravelpayouts`):
 * `null` стирает её целиком, пустой `token` в объекте значит «оставить
 * сохранённый как есть» — обратно токен не отдаётся, и прислать его форма не
 * может. Маркер без единого сохранённого в БД токена сервер не принимает
 * (422): хранить метку для ссылки, которую неоткуда взять, незачем.
 */
export type TravelpayoutsPatch = { token: string; marker: string } | null;

export interface PricesSettingsPatch {
  settings?: Partial<PricesSettings>;
  travelpayouts?: TravelpayoutsPatch;
}

/**
 * Готовность источников по мнению самого сервера: включённый в настройках
 * источник без токена или без модели считается выключенным (`readyProviders`).
 * Поля кроме `enabled` есть только у вошедшего — админка всегда вошла, но
 * читаем их защитно: форма ответа у конфига намеренно двойная.
 */
export interface PricesReadiness {
  enabled: boolean;
  providers?: Record<PriceProvider, boolean>;
  maxFlights?: number;
  dailyLimit?: number | null;
  remaining?: number | null;
}

export function fetchPricesSettings(): Promise<ApiResult<PricesSettingsView>> {
  return request<PricesSettingsView>('/api/admin/prices');
}

/**
 * `travelpayouts: undefined` — не трогать сохранённый токен; `null` — стереть
 * его (окружение остаётся фолбэком); объект — записать токен и маркер вместе.
 */
export function savePricesSettings(patch: PricesSettingsPatch): Promise<ApiResult<PricesSettingsView>> {
  return request<PricesSettingsView>('/api/admin/prices', { method: 'PUT', json: patch });
}

/** Реальная готовность источников — тем же запросом, что и у клиента фичи. */
export function fetchPricesReadiness(): Promise<ApiResult<PricesReadiness>> {
  return request<PricesReadiness>('/api/prices/config');
}
